export const HACK_GET_CATEGORIES = "HACK_GET_CATEGORIES";
export const HACK_SAVE_CATEGORIES = "HACK_SAVE_CATEGORIES";
export const HACK_GET_PRODUCTS = "HACK_GET_PRODUCTS";
export const HACK_SAVE_PRODUCTS_DATA = "HACK_SAVE_PRODUCTS_DATA";
export const HACK_MANIPULATE_DATA = "HACK_MANIPULATE_DATA";
export const HACK_GET_SHOP_DATA = "HACK_GET_SHOP_DATA";
export const HACK_SAVE_SHOP_DATA = "HACK_SAVE_SHOP_DATA";